import { FlexBoxCol } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled, { css } from 'styled-components';

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.sameHeight ? 'space-between' : 'normal'};
  padding: 8px 8px 16px 8px;
  border-radius: ${BorderRadius.OuterBlockRadius};
  min-height: 472px;
  margin-bottom: 16px;
  background: ${p => p.bgColorCard || COLORS.BgSurface};
  transition: 0.3s;
  margin: 0 auto ${props => props.oneRow ? '0' : '16px'};
  min-height: ${props => props.oneRow ? '528px' : 'auto'};

  @media (max-width: 48em) {
    max-width: 100%;
    margin: 0 auto ${props => props.oneRow ? '0' : '16px'};
  }

  ${p => p.isSmallCards && css`
    padding: 4px;
    border-radius: ${BorderRadius.InnerBlockRadius};
  `}

  :hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.07);
  }
`;

export const HeaderBlock = styled.div`
    position: absolute;
    height: 40px;
    width: 100%;
    top: 12px;
    left: 12px;
    padding: 8px;
    pointer-events: none;
    z-index: 1;
`;

export const DescriptionBlock = styled.div`
  display: flex;
  flex-direction: row;
  ${FONTS.XS};
  color: ${({ theme }) => theme.isDarkTheme ? COLORS.GRAY_LIGHT : COLORS.GRAY_DARK};
  white-space: initial;
  margin: 0 8px auto 16px;

  > div {
    height: 64px;
    overflow: hidden;
    width: 100%;
    align-content: flex-start;

    span {
        position: relative;
        display: inline-block;
        align-self: flex-end;
        background-color: ${({ theme }) => theme.isDarkTheme ? 'transparent' : COLORS.BgSurface};
        margin-bottom: -4px;

        &:after {
            position: absolute;
            content: "";
            bottom: -2px;
            left: 0;
            height: 2px;
            width: 100%;
            background-color: ${({ theme }) => theme.isDarkTheme ? 'transparent' : COLORS.BgSurface};
        }
    }
    }

    @media (max-width: 767px) {
        ${FONTS.XXS}
    }
`;

export const PurchaseBlock = styled.div`
    display: block;
    margin: 0 8px 0 16px;
`;

export const ImageBlock = styled.div`
    position: relative;
    height: 142px;
    width: 100%;
    background: ${p => p.bgColorImg || COLORS.BgMain};
    border-radius: ${BorderRadius.InnerBlockRadius};
    margin-bottom: 16px;
    position: relative;

    a {
        display: block;
        border-radius: ${BorderRadius.InnerBlockRadius};
        width: 100%;
        height: 100%;
        text-align: center;
        overflow: hidden;
    }

    img {
        height: 100%;
    }

  ${p => p.isSmallCards && css`
    height: auto;
    margin-bottom: 8px;

    img {
        width: 100%;
        height: auto;
    }
  `}
`;

export const CategoryBlock = styled.div`
    ${FONTS.XXS}
    margin: 0 8px 0 16px;
    color: ${({ theme }) => theme.isDarkTheme ? COLORS.GRAY_LIGHT : COLORS.TextInfo};
`;

export const TitleBlock = styled.div`
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 4px 8px 4px 16px;
    display: block;
    color: ${({ theme }) => theme.isDarkTheme ? COLORS.TextWhite : COLORS.TextPrimary};

    &:hover {
        overflow: visible;
        white-space: normal;
    }
    @media (max-width: 530px) {
        ${FONTS.S};
    }

    ${p => p.isSmallCards && css`
        margin: 0px 8px 8px 12px;
    `}
`;

export const Col = styled(FlexBoxCol)`
    display: ${props => props.display || 'block'};
    min-height: ${props => props.oneRow ? '528px' : 'auto'};
    max-width: 320px;

    ${p => p.isSmallCards && css`
        padding: 0;
    `}
`;
